import styled, {css} from 'styled-components'

export const StyledCollapsibleSection = styled.div(
    ({theme: {palette}}) => css`
        display: flex;
        flex-direction: column;
        width: 100%;
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        background: #fff;
    `
)

export const StyledCollapsibleHeader = styled.button(
    ({theme: {palette, spacing, typography}}) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: ${spacing * 2}px;
        padding: ${spacing * 2.5}px ${spacing * 3}px;
        background: none;
        border: none;
        cursor: pointer;
        ${typography.textSm};
        font-weight: 600;
        color: ${palette.neutral[800]};
        text-align: left;
        width: 100%;

        &:hover {
            background: ${palette.neutral[50]};
        }
    `
)

export const StyledCollapsibleHeaderLeft = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
    `
)

export const StyledChevron = styled.span<{$open: boolean}>(
    ({$open}) => css`
        display: inline-flex;
        transition: transform 0.15s ease;
        transform: rotate(${$open ? 180 : 0}deg);
    `
)

export const StyledCollapsibleBody = styled.div(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 3}px;
        border-top: 1px solid ${palette.neutral[200]};
    `
)
